// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { FormControlLabel, Checkbox } from '@mui/material';
import useStyles from './styles';

interface CheckboxInputProps {
  label: string;
  checked: boolean;
  setChecked: (value: boolean | ((prevValue: boolean) => boolean)) => void;
  disabled?: boolean;
}

const CheckboxInput = ({ label, checked, setChecked, disabled }: CheckboxInputProps) => {
  const { classes } = useStyles();
  return (
    <FormControlLabel
      className={classes.inputField}
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
};

export default CheckboxInput;
